import { jwtDecode } from "jwt-decode";

/**
 * Gets the encryption key from the stored JWT token
 * @returns {string|null} Encryption key or null if not found
 */
export const getEncryptionKeyFromToken = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (!userInfo || !userInfo.token) {
      return null;
    }

    const decoded = jwtDecode(userInfo.token) as any;
    return decoded.encryptionKey || null;
  } catch (error) {
    console.error("Error extracting encryption key:", error);
    return null;
  }
};
